import {Component, OnInit} from '@angular/core';
import {MenuItem} from "../../../services/data.model";
import {DataService} from "../../../services/data.service";

@Component({
  selector: 'psr-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {

  public menu: MenuItem[] = null;
  public isOpen = false;

  constructor(private dataService: DataService) {
    this.dataService.menu.subscribe(menu => {
      if (!!menu) {
        this.menu = [];

        menu.forEach(item => {
          if (item.url == 'https://shop.palanga.live/') {
            item.external = 100;
          }
        });
        menu.sort((a, b) => (a.order > b.order) ? 1 : -1 )
        this.menu = menu;
      }
    });
  }

  ngOnInit(): void {
  }

  toggleOpenMenu() {
    this.isOpen = !this.isOpen;
  }
}
